import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, mergeMap, of, switchMap } from 'rxjs';

import { ViewboxGdprHttpClient } from './viewbox-gdpr-http-client';
import { ViewboxGdprActions } from './viewbox-gdpr.store';

@Injectable({ providedIn: 'root' })
export class ViewboxGdprEffects {
  public loadItem$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ViewboxGdprActions.loadItem),
      mergeMap(({ payload }) =>
        this.viewboxGdprHttpClient.loadItem(payload.companyHost, payload.candidateToken).pipe(
          switchMap(gdprData => [ViewboxGdprActions.loadItemSuccess({ payload: gdprData })]),
          catchError(error => of(ViewboxGdprActions.loadItemFailed({ payload: { error } }))),
        ),
      ),
    ),
  );

  public loadConsentRequestData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ViewboxGdprActions.loadConsentRequestData),
      mergeMap(({ payload }) =>
        this.viewboxGdprHttpClient
          .loadConsentRequestData(payload.companyHost, payload.consentToken)
          .pipe(
            switchMap(data => [
              ViewboxGdprActions.loadConsentRequestDataSuccess({ payload: data }),
            ]),
            catchError(error =>
              of(ViewboxGdprActions.loadConsentRequestDataFailed({ payload: { error } })),
            ),
          ),
      ),
    ),
  );

  public newRequest$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ViewboxGdprActions.newRequest),
      mergeMap(({ payload }) =>
        this.viewboxGdprHttpClient
          .newRequest(payload.companyHost, payload.candidateToken, payload.body)
          .pipe(
            switchMap(data => [ViewboxGdprActions.newRequestSuccess({ payload: data })]),
            catchError(error => of(ViewboxGdprActions.newRequestFailed({ payload: { error } }))),
          ),
      ),
    ),
  );

  public consentRequest$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ViewboxGdprActions.consentRequest),
      mergeMap(({ payload }) =>
        this.viewboxGdprHttpClient
          .consentRequest(payload.action, payload.companyHost, payload.consentToken)
          .pipe(
            switchMap(items => [ViewboxGdprActions.consentRequestSuccess({ payload: items })]),
            catchError(error =>
              of(ViewboxGdprActions.consentRequestFailed({ payload: { error } })),
            ),
          ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private viewboxGdprHttpClient: ViewboxGdprHttpClient,
  ) {}
}
